import { render, staticRenderFns } from "./ChangeOverTimeChartLegend.vue?vue&type=template&id=12f97044&scoped=true&"
import script from "./ChangeOverTimeChartLegend.vue?vue&type=script&lang=js&"
export * from "./ChangeOverTimeChartLegend.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOverTimeChartLegend.vue?vue&type=style&index=0&id=12f97044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f97044",
  null
  
)

/* custom blocks */
import block0 from "./ChangeOverTimeChartLegend.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f97044')) {
      api.createRecord('12f97044', component.options)
    } else {
      api.reload('12f97044', component.options)
    }
    module.hot.accept("./ChangeOverTimeChartLegend.vue?vue&type=template&id=12f97044&scoped=true&", function () {
      api.rerender('12f97044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/change-over-time/ChangeOverTimeChartLegend.vue"
export default component.exports